<app-base-send-sms
  formId="sendWhiteMessageForm"
  [childTagName]="tagName"
  [config]="sendSmsConfig"
  [form]="form"
  [loading]="loading"
  [editModel]="formPageConfig.editData"
  (model)="getBaseSendSmsModel($event)"
  (privateNumber)="getPrivateNumber($event)"
  (onSubmit)="onSubmit()"
>
  <!-- senderNumber -->
  <!-- [label]="'common.messageCancelText'"  -->
  <!-- [value]="messageCancelText" -->

  <div class="row tw-mr-[1px] ltr:tw-ml-[1px] tw-mt-4" section-one-more-content>
    <div class="md:tw-w-full tw-px-0">
      <div class="tw-mb-1 alert border border-secondary tw-flex flex-column">
        <span class="tw-text-gray-800 tw-font-bold"
          >{{ "common.messageCancelText" | translate }} :
        </span>
        <span class="tw-font-normal tw-text-gray-800 tw-mt-2">
          {{ messageCancelText || "-" }}
        </span>
      </div>
    </div>
  </div>

  <!-- part 2 phonebook Recipients -->
  <fieldset class="tw-h-full" receivers>
    <legend class="tw-flex-center">
      <i class="mdi mdi-card-account-phone tw-ml-2"></i>
      {{ pageVocabs + "legends.phonebook" | translate }}
    </legend>
    <phonebook-selector
      [privateNumber]="model.senderNumberId"
      [isWhiteMessagePhonebook]="true"
      [isShowParentBtn]="false"
      (recipientsChange)="getPhonebookRecipients($event); changeFormStatus()"
      (globalIndexChange)="getGlobalIndex($event)"
    >
    </phonebook-selector>
  </fieldset>
</app-base-send-sms>
